import { theme } from '@alefeducation/ui-elements-library-core'
import styled from 'styled-components'

export const borderStyle = `1px solid ${theme.colors.primary[20]}`

export const StyledFilterPanel = styled.div`
  display: grid;
  grid-template-rows: 57px 1fr 57px;
  padding-bottom: 24px;
  align-items: flex-start;
  position: relative;
  gap: 16px;
  flex-shrink: 0;
  color: ${theme.colors.text100};
  align-self: stretch;
  background-color: ${theme.colors.primary[0]};
  width: 350px;
  height: 100%;
  max-height: 100vh;
  border-left: ${borderStyle};
  .header {
    display: flex;
    padding: 16px;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    align-self: stretch;
    border-bottom: ${borderStyle};
    > span {
      font-size: 18px;
      line-height: 133.33%;
    }
  }
  .panel {
    padding: 16px;
    width: 100%;
    padding-bottom: 100px;
    max-height: 100%;
    overflow: auto;
    // some CSS hack fix for accordion header margin
    > div > div > div:first-child > div > div:first-child {
      gap: 8px;
      > div {
        margin: 0;
        user-select: none;
      }
    }
    // HACK END
    > div {
      // accrodion item wrapper
      display: flex;
      gap: 12px;
      flex-direction: column;
    }

    .panel-item {
      display: flex;
      flex-direction: column;
      gap: 8px;
      margin-left: 20px;
      margin-top: 8px;
    }
  }
  .footer {
    display: flex;
    flex-wrap: wrap;
    align-content: center;
    justify-content: center;
    align-items: center;
    gap: 16px;
    width: 100%;
    padding-top: 16px;
    border-top: 1px solid #e3e3e3;
  }
`
